export default {
    scrollTo:{
        subtract : 0
    }
}